import { Link } from "react-router-dom";

const services = [
  {
    id: 1,
    number: "01",
    icon: "ri-radar-line",
    title: "海底ケーブル敷設工事",
    description: "ルート調査、布設作業、ブイカット、防護管取り付け、埋設作業",
    anchor: "/services#cable",
  },
  {
    id: 2,
    number: "02",
    icon: "ri-shield-check-line",
    title: "防食工事",
    description: "港湾・河川・海岸構造物の腐食を防ぐ防食カバー取り付けや防食ライニング工法を実施。",
    anchor: "/services#anticorrosion",
  },
  {
    id: 3,
    number: "03",
    icon: "ri-anchor-line",
    title: "港湾工事",
    description: "岸壁補修、護岸整備、係船設備設置など、港湾施設の新設から補修まで一貫対応。",
    anchor: "/services#harbor",
  },
  {
    id: 4,
    number: "04",
    icon: "ri-ship-line",
    title: "サルベージ作業",
    description: "サルベージに関わる作業全般をサポートします。",
    anchor: "/services#salvage",
  },
  {
    id: 5,
    number: "05",
    icon: "ri-user-search-line",
    title: "SV対応業務",
    description: "海外現地から船上までSV業務にまつわる業務全般を行います。",
    anchor: "/services#sv",
  },
  {
    id: 6,
    number: "06",
    icon: "ri-flashlight-line",
    title: "電気通信工事",
    description: "海底ケーブル電気通信、移動体通信、住宅機器取付工事まで幅広くご対応いたします。",
    anchor: "/services#electrical",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-16 md:py-24 bg-ocean-50">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-widest text-ocean-500 border border-ocean-500 rounded-full mb-4">
            OUR SERVICES
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-ocean-800 mb-4">
            事業内容
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.anchor}
              className="group block rounded-xl p-6 md:p-8 bg-ocean-800 hover:bg-ocean-700 hover:ring-2 hover:ring-ocean-500 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-ocean-700 group-hover:bg-ocean-600 text-ocean-300 transition-colors">
                  <i className={`${service.icon} text-2xl`} />
                </div>
                <span className="text-3xl font-bold text-white/20 font-serif">
                  {service.number}
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-white/60 leading-relaxed mb-4">
                {service.description}
              </p>
              <div className="flex items-center gap-1 text-ocean-300 text-sm font-medium group-hover:text-ocean-200 transition-colors">
                <span>詳しく見る</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
